var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgStarted = function SvgStarted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "currentColor"
  })));
};
export default __webpack_public_path__ + "assets/42a6fc00bab330f3c9be019ed1d81b3c.svg";
export { SvgStarted as ReactComponent };


// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Status/assets/icons/started.svg